import styled, { keyframes } from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

const ProjectList = styled.div`
  padding: var(--space-12) var(--space-12) var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;
const Title = styled.div`
  padding-left: var(--space-8);
  color: var(--text-secondary);
  ${Typography.body_sm_medium}
`;
const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  max-height: 230px;
  ${HideScrollbar}
`;
const ListItem = styled.div`
  cursor: pointer;
  ${AlignCenter}
  gap: var(--space-8);
  padding: var(--space-5) var(--space-8);
  border-radius: var(--border-radius-8);
  &:hover {
    background-color: var(--neutral-secondary);
  }
  p {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.body_md}
  }
`;
const LockIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Box = styled.div`
  min-height: 280px;
  margin: auto;
  display: flex;
  position: relative;
`;
const Text = styled.div`
  color: var(--text-tertiary);
  ${Typography.body_lg_medium};
`;
const LoadingDiv = styled.div`
  ${FlexCenter}
  flex-direction: column;
`;
const ball = keyframes`
  from {
    -webkit-transform: translateY(0) scaleY(0.8);
    transform: translateY(0) scaleY(0.8);
  }
  to {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
`;
const Loading = styled.div``;
const LoadingWrap = styled.div`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 36px;
  &::before {
    position: absolute;
    top: 50%;
    left: calc(50% - 2px);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: var(--border-radius-full);
    background-color: var(--brand-primary);
    z-index: var(--z-index-base);
    margin-top: var(--space-4);
    -webkit-animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
    animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
    -webkit-animation-delay: 0.15s;
    animation-delay: 0.15s;
  }
  ${Loading} {
    cursor: wait;
    color: transparent;
    &:hover {
      cursor: wait;
    }
    &::before {
      position: absolute;
      top: 50%;
      left: calc(50% - 2px);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      border-radius: var(--border-radius-full);
      background-color: var(--brand-primary);
      z-index: var(--z-index-base);
      margin-top: var(--space-4);
      -webkit-animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
      animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
      margin-left: -12px;
    }
    &::after {
      position: absolute;
      top: 50%;
      left: calc(50% - 2px);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      border-radius: var(--border-radius-full);
      background-color: var(--brand-primary);
      z-index: var(--z-index-base);
      margin-top: var(--space-4);
      -webkit-animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
      animation: 0.45s cubic-bezier(0, 0, 0.15, 1) infinite alternate ${ball};
      margin-left: var(--space-12);
      -webkit-animation-delay: 0.3s;
      animation-delay: 0.3s;
    }
  }
`;

export { ProjectList, Title, Items, ListItem, LockIcon, Box, Text, LoadingDiv, LoadingWrap, ball, Loading };
